import { render, staticRenderFns } from "./CampaignIsPaused.vue?vue&type=template&id=5bb2fb4a&scoped=true&"
import script from "./CampaignIsPaused.vue?vue&type=script&lang=js&"
export * from "./CampaignIsPaused.vue?vue&type=script&lang=js&"
import style0 from "./CampaignIsPaused.vue?vue&type=style&index=0&id=5bb2fb4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb2fb4a",
  null
  
)

export default component.exports